import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Token } from './model/token.interface';
import { AcceptedTermsOfUse } from './model/accepted-terms-of-use.interface';
import { HeaderForAuthentication } from './model/header-for-authentication.model';
import { ValidateParameters } from '../../parameter-validators';
import { User } from './model/user.interface';


@Injectable({ providedIn: 'root' })
export class AuthApiUserService {

  constructor(private httpClient: HttpClient) {
  }

  login$(username: string, password: string, code: string, termsOfUse: AcceptedTermsOfUse[]): Observable<Token> {
    return this.httpClient.post<Token>('/cloud-service-auth/auth', {
      name: username.toLowerCase(),
      password,
      code,
      lifetime: 1000 * 60 * 30,
      termsOfUse,
    });
  }

  logout$(): Observable<Object> {
    return this.httpClient.delete<Object>('/cloud-service-auth/auth', {
      headers: new HeaderForAuthentication(),
    });
  }

  @ValidateParameters
  readSelfUser$(accountId?: string): Observable<User> {
    const url = '/cloud-service-auth/users/self';
    const options = {
      headers: new HeaderForAuthentication(accountId ? [accountId] : []),
    };
    return this.httpClient.get<User>(url, options);
  }
}
